import React, { useEffect, useState } from "react";
import styles from "../Pages/Projects.module.css";
import { API } from "../config";

const BASE_URL = API.portfolio;

function Projects() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!BASE_URL) throw new Error("API URL is not configured");

        const res = await fetch(BASE_URL);
        if (!res.ok) throw new Error("Failed to fetch data");

        const data = await res.json();
        setProjects(data.projects || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <p className={styles.loading}>Loading projects...</p>;
  if (error) return <p className={styles.error}>Error: {error}</p>;
  if (!projects.length)
    return <p className={styles.noProjects}>No projects found.</p>;

  return (
    <section id="projects" className={styles.maincontainer}>
      <div className={styles.recent}>
        <h2 className={styles.head}>RECENT</h2>
        <h2 className={styles.pro}>PROJECTS</h2>
      </div>

      <div className={styles.projodiv}>
        {projects.map((proj) => (
          <div key={proj._id} className={styles.projcard}>
            
            {/* Image */}
            <div className={styles.projimg}>
              <img
                src={proj.image || "/fallback-image.jpg"}
                alt={proj.name || "Project image"}
              />
            </div>

            {/* Text */}
            <div className={styles.projtxt}>
              <p className={styles.projhead}>{proj.name}</p>
              <p className={styles.projdes}>{proj.description}</p>
            </div>

            {/* External Link */}
            {proj.link && (
              <div className={styles.upicon}>
                <a
                  href={proj.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Visit ${proj.name}`}
                >
                  <svg
                    className={styles.upiconsvg}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true"
                  >
                    <line
                      x1="7"
                      y1="17"
                      x2="17"
                      y2="7"
                      stroke="#ff6b35"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <polyline
                      points="13,7 17,7 17,11"
                      stroke="#ff6b35"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                  </svg>
                </a>
              </div>
            )}

          </div>
        ))}
      </div>
    </section>
  );
}

export default Projects;